import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CONST_AWS_API } from 'src/app/core/constants';
import { API as AWS_API } from 'aws-amplify';
import { environment } from 'src/environments/environment';
import { CommanSubscribeService } from './../../../../../../core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
// import { AppService } from 'src/app/core/services/app.service';

declare let $: any;
@Component({
  selector: 'app-expo-list',
  templateUrl: './expo-list.component.html',
  styleUrls: ['./expo-list.component.scss']
})
export class ExpoListComponent implements OnInit {
  userInfo: any;
  event_id = '';
  sponsorArr = [];
  startupArr = [];
  scholarArr = [];
  pitchArr = [];
  techArr = [];
  vendorsList: any = [];
  selectedExpo: any = 'All';
  showVendor: boolean = false;
  showFilter: boolean;
  sponsorsList: any = [];
  startupList: any[];
  scholarList: any[];
  pitchesList: any = [];
  technologyList: any = [];
  slugInfoSubscr: Subscription;
  slugInfo: any;
  dataExists: boolean = false;
  getCurrency: any;
  currentLocation: any;
  key: any;
  selectedVal=2;
  ip:any = null;
  streamAdsData: any;
  sponsorData: any;
  preloadAdsdata: any[];
  adVideo: any;
  allAds: any;
  eventHomeAdsTop: any[];
  eventHomeAdsRight: any[];
  streamAdsDataRight: any[];
  streamAdsDataTop: any[];
  streamAds: any;
  streamInfoData: any;
  streamInfo: any = {};
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private commanSubscribeService: CommanSubscribeService,
    private ngxLoader: NgxUiLoaderService,
    private sanitizer: DomSanitizer,
    // private appService: AppService,
  ) { }

  ngOnInit() {
    let device = this.commanSubscribeService.getMobileOperatingSystem();
    if (device == 'ios' || device == 'android') {
      this.commanSubscribeService.sendScreenStatus(true);
    }
    this.userInfo = this.commanSubscribeService.userInfo;
    this.slugInfo = this.commanSubscribeService.slugInfo;
    this.slugInfoSubscr = this.commanSubscribeService.getSlugData().subscribe(response => {
      this.slugInfo = response;
      this.eventDetails(this.slugInfo);
    })
    // this.eventDetails(this.slugInfo);
    console.log(this.slugInfo);
    this.vendorsList = ['All', 'Sponsors', 'Startups', 'Pitches', 'Film and Technology'];
    // this.vendorsList = ['All','Sponsors', 'Startups', 'Research Scholar'];
    let id = this.route.snapshot.params.ticket_key, key: any;
    if (id.includes('-')) {
      this.key = id.split('-');
      this.event_id = this.key[0];
    } else {
      this.event_id = id;
    }
    this.getExpoList();
  }
 
  expoList=[];
  expoResp = [];
  getExpoList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXPO_LIST + '/' + this.event_id;
    this.ngxLoader.start();
    API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.commanSubscribeService.sendSlugData(response['data']['stream_info']);
        this.ngxLoader.stop();
        this.selectedExpo = 'All';
        // let sArr = [], stArr = [], rsArr = [], piArr = [], ftArr = [];
        // this.sponsorArr = []; this.startupArr = []; this.scholarArr = [];
        this.expoList = response['data']['Data'];
        this.groupExpoByType();
        // response.data.Data.forEach(element => {
        //   if (element.type == 'sponsor') {
        //     sArr.push(element);
        //     this.sponsorsList = sArr;
        //     if (this.selectedVendor != 'Sponsors' && sArr.length > 0) {
        //       this.sponsorArr = sArr.slice(0, 2);
        //     }
        //   } else if (element.type == 'startups') {
        //     stArr.push(element);
        //     this.startupList = stArr;
        //     if (this.selectedVendor != 'Startups' && stArr.length > 0) {
        //       this.startupArr = stArr.slice(0, 2);
        //     }
        //   } else if (element.type == 'research_and_scholar') {
        //     rsArr.push(element);
        //     this.scholarList = rsArr;
        //     if (this.selectedVendor != 'Research and Scholar' && rsArr.length > 0) {
        //       this.scholarArr = rsArr.slice(0, 2);
        //     }
        //   } else if (element.type == 'pitches') {
        //     piArr.push(element);
        //     this.pitchesList = piArr;
        //     if (this.selectedVendor != 'Pitches' && piArr.length > 0) {
        //       this.pitchArr = piArr.slice(0, 2);
        //     }
        //   } else if (element.type == 'film_and_technology') {
        //     ftArr.push(element);
        //     this.technologyList = ftArr;
        //     if (this.selectedVendor != 'Film and Technology' && ftArr.length > 0) {
        //       this.techArr = ftArr.slice(0, 2);
        //     }
        //   }
        // });
        this.dataExists = true;
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }

  goDetails(id) {
    let ids = {
      "stream_id": this.event_id,
      "userid": this.key ? this.key[1] : this.userInfo.id,
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: ids
    }
    this.ngxLoader.start();
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
      this.ngxLoader.stop();
      this.slugInfo = response['data']['Data'];
      this.commanSubscribeService.sendSlugData(response['data']['Data']);
      if ((this.slugInfo && this.slugInfo.user_subscription_info && this.slugInfo.user_subscription_info.length > 0) || this.router.url.includes('schedule'))
        this.router.navigate([`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/expo-details/` + id + '/' + this.slugInfo.user_subscription_info[0].ticket_key]);
      else if ((this.slugInfo.stream_info.stream_payment_mode == 'free' && !this.slugInfo.price_details) || (this.slugInfo.stream_info.stream_payment_mode == 'paid' && this.slugInfo.price_details && !this.slugInfo.price_details.message) || (this.slugInfo.user_subscription_info && this.slugInfo.user_subscription_info.length > 0 && this.slugInfo.user_subscription_info[0].transaction_status != "Completed")) {
        if (Object.keys(this.route.snapshot.queryParams).length > 0)
          this.router.navigate([`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/` + this.slugInfo.slug + '/place-order'], { queryParams: { ref: this.route.snapshot.queryParams.ref } });
        else
          this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/${this.slugInfo.slug}/place-order`);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

  // goDetails(id) {
  //   console.log("id", id);
  //   if ((this.slugInfo && this.slugInfo.user_subscription_info && this.slugInfo.user_subscription_info.length > 0) || this.router.url.includes('schedule'))
  //     this.router.navigate(['/event/expo-details/' + id +'/'+ this.slugInfo.user_subscription_info[0].ticket_key]);
  //   else if ((this.slugInfo.stream_info.stream_payment_mode =='free' && !this.slugInfo.price_details)  ||(this.slugInfo.stream_info.stream_payment_mode =='paid' && this.slugInfo.price_details && !this.slugInfo.price_details.message) || (this.slugInfo.user_subscription_info && this.slugInfo.user_subscription_info.length > 0 && this.slugInfo.user_subscription_info[0].transaction_status != "Completed")) {
  //     if (Object.keys(this.route.snapshot.queryParams).length > 0)
  //       this.router.navigate(['/event/' + this.slugInfo.slug + '/place-order'], { queryParams: { ref: this.route.snapshot.queryParams.ref } });
  //     else
  //       this.router.navigateByUrl(`event/${this.slugInfo.slug}/place-order`);
  //   }
  // } 

  groupExpoByType() {
    this.expoList = this.expoList.sort((a, b) => a.expo_order > b.expo_order ? 1 : -1);
    const grouped = this.expoList.reduce((groups, expo) => {
      const pos = expo.type;
      groups[pos] = groups[pos] || [];
      groups[pos].push(expo);
      return groups;
    }, {});
    this.expoResp = this.expoList = Object.keys(grouped).map(key => ({ type: key, expoData: grouped[key] }));
  }

  toggleFilter(type) {
    if (type == 'filter') {
      this.showFilter = !this.showFilter;
      this.selectedExpo = 'All'
    } else {
      this.showVendor = !this.showVendor;
    }
  }

  getSelectedExpo(expo, type?) {
    this.showVendor = false;
    if (type == 'all' || type == 'All'){
      this.expoList = this.expoResp;
      this.selectedExpo = 'All';
      this.selectedVal = 2;
    }
    if (type != 'all'){
      this.selectedExpo = expo.type;
      this.expoList = [];
      this.expoResp.forEach(e=>{
        if(e.type == expo.type){
          this.expoList.push(e);
          this.selectedVal = e.expoData.length;
        }
      })
    }
    // if (this.selectedVendor == 'Sponsors')
    //   this.sponsorArr = this.sponsorsList;
    // else if (this.selectedVendor == 'Startups')
    //   this.startupArr = this.startupList;
    // else if (this.selectedVendor == 'Research Scholar')
    //   this.scholarArr = this.scholarList;
    // else if (this.selectedVendor == 'Pitches')
    //   this.pitchArr = this.pitchesList;
    // else if (this.selectedVendor == 'Film and Technology')
    //   this.techArr = this.technologyList;
  }

  loadAdsScript() {
    document.querySelectorAll('.videoAds').forEach(vid => (<HTMLVideoElement>vid).pause());
    $('.carousel-inner img').attr('alt', '');
    $('.carousel-inner img').attr('title', '');
    var t;
    var start = $('#myCarousel').find('.active').attr('id');
    t = setTimeout("$('#myCarousel').carousel({interval: 1000});", start - 1000);
    $('#myCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(t);
      var duration1 = $(this).find('.active').attr('id');
      console.log(duration1);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#myCarousel').carousel('pause');
      t = setTimeout("$('#myCarousel').carousel();", duration1 - 1000);
    })
    $('.carousel-control-next').on('click', () => {
      clearTimeout(t);
    });
    $('.carousel-control-prev').on('click', () => {
      clearTimeout(t);
    });
    var r;
    var start = $('#RightCarousel').find('.active').attr('id');
    r = setTimeout("$('#RightCarousel').carousel({interval: 1000});", start - 1000);
    $('#RightCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(r);
      var duration2 = $(this).find('.active').attr('id');
      console.log(duration2);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#RightCarousel').carousel('pause');
      r = setTimeout("$('#RightCarousel').carousel();", duration2 - 1000);
    })
    $('.carousel-control-next').on('click', () => {
      clearTimeout(r);
    });
    $('.carousel-control-prev').on('click', () => {
      clearTimeout(r);
    });
  }

  eventDetails(slugInfo) {
    this.streamAds = slugInfo['stream_info']['stream_ads'];
    console.log('All ads from dynamo', this.streamAds);
    this.streamAdsData = [];
    if (this.streamAds && this.streamAds.length > 0) {
      this.streamAds.forEach(element => {
        if (element.ad_size && element.ad_size == "728x90" || element.ad_size == "300x600") {
          this.streamAdsData.push(element);
        }
      });
      console.log('Schedule page ads from dynamo', this.streamAdsData);
      if (this.streamAdsData.length > 0) {
        this.getAds();
      }
    }

  }
  selectedAdData: any;
  async getAds() {
    let allDiv = [];
    let count = 0;

    var temp_site_id = null;
    this.preloadAdsdata = [];
    if (this.streamAdsData && this.streamAdsData.length > 0) {
      this.sponsorData = this.streamAdsData;
      var j = 0;
      var i = 1;

      var adTypeIdarr = [];
      var placements = [];
      this.streamAdsData.forEach(el => {
        temp_site_id = Number(el.site_id)
        j += 1;
        adTypeIdarr.push(el.adTypeId);
        placements.push({
          "divName": "div" + i + j,
          "networkId": Number(environment.kevel.NETWORK_ID),
          "siteId": Number(el.site_id),
          "adTypes": [el.adTypeId],
          "campaignId": Number(el.campaignId),
          "flightId": Number(el.flight_id),
          "adId": Number(el.ad_id)
        });
        allDiv.push("div" + i + j);
        count = count + 1;
        if (this.streamAdsData.length == count) {
          let data = {
            "placements": placements,
            "allDiv": allDiv
          };
          if (temp_site_id) {
            this.eventHomeAdsTop = [];
            this.eventHomeAdsRight = [];
            this.commanSubscribeService.getAdsData(data, (err, result) => {
              this.preloadAdsdata = result.Ads_data;
              console.log("Schedule page Ads :::: ", this.preloadAdsdata);
              if (this.preloadAdsdata.length > 0) {
                this.preloadAdsdata.forEach(element => {
                  this.selectedAdData = element.clickUrl;
                  console.log('eventHomeAdsRight selectedAdData :: ', this.selectedAdData);
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 728 && element.height == 90) {
                    let adType = element.contents[0];
                    let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    this.adVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsTop.push({ 'image': this.adVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 300 && element.height == 600) {
                    let adType = element.contents[0];
                    // let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    let rightsadVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsRight.push({ 'image': rightsadVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                });
                console.log('scheduleAdsTop :: ', this.eventHomeAdsTop);
                console.log('scheduleAdsRight :: ', this.eventHomeAdsRight);
                setTimeout(() => {
                  this.loadAdsScript();
                }, 200);
              }
            });
          }
        }
      });
    }
  }
  ngOnDestroy() {
    if (this.slugInfoSubscr)
      this.slugInfoSubscr.unsubscribe();
  }

}
